import React, { useEffect, useState, Fragment } from 'react'
import { clubApi } from 'data/resources/clubs'
import { withRouter } from 'react-router'
import { LayoutTop } from 'features/organizations_legacy/Layout'
import { base } from 'lib/styleguide/base.scss'
import { GlobalNav } from 'common/GlobalNav'
import { GlobalFooter } from 'common/GlobalFooter'

const _OrganizationLayout = ({ children, params }) => {
  const [{ club, layoutConfig }, setClubAndLayoutConfig] = useState({})

  useEffect(() => {
    const clubId = parseInt(params.clubIdParam, 10)
    clubApi.read(clubId).then(({ club, meta: { layoutConfig } }) => {
      setClubAndLayoutConfig({ club, layoutConfig })
    })
  }, [])

  return (
    <div className={base}>
      <GlobalNav />
      {club && <Fragment>
        <LayoutTop params={params} organization={club} {...layoutConfig} />
        {children}
      </Fragment>}
      <GlobalFooter />
    </div>
  )
}

export const OrganizationLayout = withRouter(_OrganizationLayout)
